import { getExternalLink } from 'cadenza/api-client/external-links-api';
import { type ExternalBaseLinkIdTuple } from 'cadenza/repository/model/external-base-link-id';

export async function getTargetOrigin (baseLinkId: ExternalBaseLinkIdTuple) {
  const baseLink = await getExternalLink(baseLinkId);
  if (baseLink.allowPostMessage) {
    return new URL(baseLink.urlPart).origin;
  }
}
